import initialState from './UserInitialState';
import reducers from './UserReducer';

export default {
  initialState,
  reducers,
};
